import { Box } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useState } from "react";

interface IRegisterPasswordRule {
    isRuleFulfilled: boolean;
    ruleContent: string;
}

export default function RegisterPasswordRule({
    isRuleFulfilled,
    ruleContent
}: IRegisterPasswordRule): JSX.Element {

    return (
        <Box
            display="flex"
            alignItems="center"
            marginBottom="8px"
        >
            <Box 
                width="6px"
                height="6px"
                borderRadius="50%"
                bgcolor={isRuleFulfilled ? "#4eea78ff" : "#D3E0E8"}
                marginRight="8px"
            />
            <KeyDriveBodyMin 
                color="#2D2D2D"
                needBold={false}
                needEllipses={false}
                text={ruleContent}
            />
        </Box>
    )
}